// Reactive (Vue.observable-based) sidebar state, shared between TopBar.vue
// (the toggle buttons) and SideBar.vue/TemplateDashboard.vue (which react to it), the
// same cross-component pattern modalStore.js uses.
import Vue from 'vue';

const STORAGE_KEY = 'sidebarCollapsed';

// Matches Tailwind's `lg` breakpoint: below it the sidebar is an off-canvas drawer,
// at or above it the sidebar is docked (expanded or collapsed to an icon rail).
const DESKTOP_QUERY = '(min-width: 64rem)';
const desktopMedia = window.matchMedia(DESKTOP_QUERY);

const state = Vue.observable({
    collapsed: localStorage.getItem(STORAGE_KEY) === 'true',
    // True while the mouse is hovering a collapsed sidebar, temporarily previewing
    // it at full width. Kept separate from `collapsed` (the locked toggle state).
    hovering: false,
    // Drawer visibility below the `lg` breakpoint; ignored on desktop.
    mobileOpen: false,
    isDesktop: desktopMedia.matches,
});

function handleBreakpointChange(event) {
    state.isDesktop = event.matches;
    // Touch taps fire mouseenter without a matching mouseleave; never carry a
    // stale hover preview across breakpoints.
    state.hovering = false;
    if (event.matches) state.mobileOpen = false;
}

// Safari < 14 only supports the deprecated addListener API.
if (desktopMedia.addEventListener) {
    desktopMedia.addEventListener('change', handleBreakpointChange);
} else {
    desktopMedia.addListener(handleBreakpointChange);
}

export function toggleSidebar() {
    state.collapsed = !state.collapsed;
    localStorage.setItem(STORAGE_KEY, state.collapsed);
}

export function isSidebarCollapsed() {
    return state.collapsed;
}

export function setSidebarHovering(value) {
    // Hover preview only applies to the docked desktop sidebar.
    state.hovering = state.isDesktop && value;
}

// What the sidebar's own width/labels and the header's offset should follow:
// collapsed, unless a hover preview is currently expanding it. The mobile drawer
// always shows full labels.
export function isSidebarEffectivelyCollapsed() {
    return state.isDesktop && state.collapsed && !state.hovering;
}

export function isMobileSidebarOpen() {
    return state.mobileOpen;
}

export function toggleMobileSidebar() {
    state.mobileOpen = !state.mobileOpen;
}

export function closeMobileSidebar() {
    state.mobileOpen = false;
}
